import { generateLiningsGradient } from 'src/util/canvas'
import { topSidePartOfWeb } from './parts/sideParts'
import { drawWithImagePatternWrapper } from 'src/util/canvasImagePattern'

const checkCellParts = (ctx: CanvasRenderingContext2D, webColor: CanvasGradient | 'white', x: number, y: number, numerator?: number) => {
  ctx.fillStyle = webColor
  ctx.beginPath()
  if (numerator !== undefined && numerator !== 0) {
    ctx.save()
    ctx.rotate((numerator * Math.PI) / 180)
  }
  ctx.moveTo(313 + x, 175 + y) //
  ctx.quadraticCurveTo(314 + x, 186 + y, 317 + x, 195 + y)
  ctx.quadraticCurveTo(328 + x, 185 + y, 338 + x, 174 + y)
  ctx.quadraticCurveTo(338 + x, 163 + y, 333 + x, 153 + y)
  ctx.quadraticCurveTo(320 + x, 170 + y, 313 + x, 175 + y)
  ctx.stroke()
  ctx.fill()
  ctx.strokeStyle = '#282828'
  if (numerator !== undefined) {
    ctx.restore()
  }
  ctx.closePath()
}

export const basketForPitcherWeb = async (
  ctx: CanvasRenderingContext2D,
  webColor: string,
  laceColor: string,
  stitchColor: string,
  printLeatherTypeValue?: string
): Promise<void> => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'

  // ウェブ本体
  const drawWebBody = () => {
    ctx.beginPath()
    ctx.moveTo(300, 376) // 左下
    ctx.quadraticCurveTo(339, 334, 373, 252) // 右下
    ctx.quadraticCurveTo(384, 159, 359, 92) // 右上
    ctx.quadraticCurveTo(269, 153, 210, 260) // 左上
    ctx.quadraticCurveTo(300, 376, 300, 376) // 左下
    ctx.fill()
    ctx.stroke()
    ctx.closePath()
  }

  await drawWithImagePatternWrapper(ctx, printLeatherTypeValue, drawWebBody, webColor)

  // バスケット部分
  ctx.beginPath()
  ctx.moveTo(250, 264) // 左上
  ctx.quadraticCurveTo(288, 333, 295, 348) // 左下1
  ctx.quadraticCurveTo(322, 305, 360, 245) // 右下1
  ctx.quadraticCurveTo(342, 151, 332, 151) // 右上1
  ctx.quadraticCurveTo(284, 198, 250, 264) // 左上1
  ctx.stroke()
  ctx.closePath()

  const coordinates = { x0: 50, y0: 300, x1: 300, y1: 400 }
  const isLeatherPrint = printLeatherTypeValue && printLeatherTypeValue !== 'unselected' && printLeatherTypeValue !== 'none'
  const gradient = generateLiningsGradient(ctx, webColor, coordinates)
  const webPartsColor = isLeatherPrint ? 'white' : gradient

  // 1段目
  checkCellParts(ctx, webPartsColor, 0, 0, 0)
  checkCellParts(ctx, webPartsColor, -52, 59, -5)
  checkCellParts(ctx, webPartsColor, -100, 113, -8)
  // 2段目
  checkCellParts(ctx, webPartsColor, -12, 38, 0)
  checkCellParts(ctx, webPartsColor, -64, 100, -5)
  // 3段目
  checkCellParts(ctx, webPartsColor, 14, 39, 0)
  checkCellParts(ctx, webPartsColor, -39, 100, -5)
  checkCellParts(ctx, webPartsColor, -88, 150, -8)
  // 4段目
  checkCellParts(ctx, webPartsColor, -17, 103, -5)
  checkCellParts(ctx, webPartsColor, -50, 140, -5)
  // 5段目
  checkCellParts(ctx, webPartsColor, 5, 105, -4)
  checkCellParts(ctx, webPartsColor, -45, 158, -8)
  checkCellParts(ctx, webPartsColor, -75, 189, -8)

  // stitchここから
  ctx.beginPath()
  ctx.strokeStyle = stitchColor
  ctx.setLineDash([3, 3])
  // バスケットの周り
  // 内側
  ctx.moveTo(247, 265) //左上
  ctx.quadraticCurveTo(288, 337, 295, 355) // 左下
  ctx.quadraticCurveTo(323, 307, 363, 248) // 右下
  ctx.quadraticCurveTo(344, 146, 334, 146) // 右上
  ctx.quadraticCurveTo(281, 194, 247, 265) // 左上
  // 外側
  ctx.moveTo(242, 265) //左上
  ctx.quadraticCurveTo(290, 341, 293, 360) // 左下
  ctx.quadraticCurveTo(328, 305, 366, 250) // 右下
  ctx.quadraticCurveTo(345, 140, 338, 144) // 右上
  ctx.quadraticCurveTo(278, 191, 242, 265) // 左上
  ctx.stroke()
  ctx.setLineDash([])
  ctx.strokeStyle = laceColor
  ctx.closePath()
  // stitchここまで
  // ウェブ先端
  await topSidePartOfWeb(ctx, webColor, laceColor, stitchColor, printLeatherTypeValue)
}
